import { MapPin, Phone, MessageCircle, Facebook, Music2, Instagram, Navigation, Clock } from "lucide-react";
import { CONTACTS } from "../data/site";
import { Reveal, SectionLabel } from "../components/Reveal";
import { useLang } from "../i18n";

const DAYS = [
  { key: "d.lun", closed: true },
  { key: "d.mar" },
  { key: "d.mer" },
  { key: "d.gio" },
  { key: "d.ven" },
  { key: "d.sab" },
  { key: "d.dom" },
];

export default function Contatti() {
  const { t } = useLang();
  return (
    <main className="pt-20" data-testid="contatti-page">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-16">
        <Reveal>
          <SectionLabel number="·">{t("c.label")}</SectionLabel>
          <h1 className="font-display uppercase leading-[0.9] tracking-tight text-6xl sm:text-8xl text-foreground">
            <span className="text-foreground">{t("c.title").slice(0, 3)}</span><span className="text-outline-lime">{t("c.title").slice(3)}</span>
          </h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-5">
          <Reveal>
            <div className="border border-neon/20 bg-pine p-7 rounded-sm" data-testid="contatti-address-card">
              <MapPin size={22} className="text-neon mb-4" />
              <h3 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-fog mb-2">{t("c.address")}</h3>
              <p className="text-foreground text-xl font-head">{CONTACTS.address}</p>
              <a href={CONTACTS.mapsDirections} target="_blank" rel="noopener noreferrer" data-testid="contatti-directions-btn"
                className="inline-flex items-center gap-2 mt-5 bg-neon text-ink font-head font-bold text-xs tracking-[0.2em] uppercase px-6 py-3 rounded-full transition-transform duration-300 hover:scale-105">
                <Navigation size={15} /> {t("c.directions")}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="border border-neon/20 bg-pine p-7 rounded-sm" data-testid="contatti-phone-card">
              <Phone size={22} className="text-neon mb-4" />
              <h3 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-fog mb-2">{t("c.phoneTitle")}</h3>
              <a href={CONTACTS.phoneHref} className="text-foreground text-xl font-head hover:text-neon transition-colors duration-300" data-testid="contatti-phone-link">
                {CONTACTS.phone}
              </a>
              <div className="flex gap-3 mt-5">
                <a href={CONTACTS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="contatti-whatsapp-btn"
                  className="flex-1 flex items-center justify-center gap-2 border border-neon text-neon font-head font-bold text-xs tracking-[0.2em] uppercase px-4 py-3 rounded-full hover:bg-neon hover:text-ink transition-colors duration-300">
                  <MessageCircle size={15} /> WhatsApp
                </a>
                <a href={CONTACTS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="contatti-facebook-btn"
                  className="w-12 border border-neon/30 flex items-center justify-center text-fog hover:bg-neon hover:text-ink transition-colors duration-300 rounded-full">
                  <Facebook size={16} />
                </a>
                <a href={CONTACTS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="contatti-instagram-btn"
                  className="w-12 border border-neon/30 flex items-center justify-center text-fog hover:bg-neon hover:text-ink transition-colors duration-300 rounded-full">
                  <Instagram size={16} />
                </a>
                <a href={CONTACTS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="contatti-tiktok-btn"
                  className="w-12 border border-neon/30 flex items-center justify-center text-fog hover:bg-neon hover:text-ink transition-colors duration-300 rounded-full">
                  <Music2 size={16} />
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="border border-neon/20 bg-pine p-7 rounded-sm" data-testid="contatti-hours-card">
              <Clock size={22} className="text-neon mb-4" />
              <h3 className="font-head font-bold uppercase tracking-[0.2em] text-sm text-fog mb-4">{t("c.hoursTitle")}</h3>
              <ul className="space-y-2.5">
                {DAYS.map((d) => (
                  <li key={d.key} className="flex items-baseline gap-3 text-sm" data-testid={`hours-${d.key.replace("d.", "")}`}>
                    <span className="text-foreground font-head font-semibold uppercase tracking-wide">{t(d.key)}</span>
                    <span className="flex-1 border-b border-dotted border-foreground/20 -translate-y-1" />
                    <span className={d.closed ? "text-neon font-semibold" : "text-fog"}>
                      {d.closed ? t("c.closed") : "19:00 — 00:00"}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1} className="h-full">
            <div className="relative h-full min-h-[420px]">
              <iframe
                title="Mappa Pizzeria Bella Acireale"
                src={CONTACTS.mapsEmbed}
                className="relative w-full h-full min-h-[420px] border-0 rounded-sm grayscale-[20%] contrast-[1.05]"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contatti-map"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
